import { Component, OnInit, ViewChild } from '@angular/core';
import { InductionService } from './../../services/induction.service';
import { FilterService } from "./../../services/filter.service";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatSnackBar } from '@angular/material';
import { saveAs } from "file-saver";
import { FilesComponent } from 'src/app/files/files.component';

@Component({
  selector: 'app-induction-records',
  templateUrl: './induction-records.component.html',
  styleUrls: ['./induction-records.component.scss']
})

export class InductionRecordsComponent implements OnInit {
  loading: Boolean;
  inductees: any = []
  pageSizeOptions: number[] = [25, 50, 100];
  displayedColumns: string[] = ['name', 'actions'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  noDataMsg = {
    title: "No Inductees!",
    data: "You have not yet added any inductees"
  }
  load = false
  selectedIndex
  selected_filename;
  // sort: MatSort;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  afterFilter: any;
  filterActive: Boolean = false;

  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    console.log(" mp ", mp)
    this.paginator = mp;
    console.log(" paginator 1", this.paginator)

    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    console.log(" paginator 2", this.paginator)
    this.updateData([])
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }


  constructor(public _inductionService: InductionService, public _filter: FilterService, public _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.loading = true;
    this.getInductions();
    const paginatorIntl = this.paginator._intl;
    paginatorIntl.nextPageLabel = '';
    paginatorIntl.previousPageLabel = '';
  }


  getInductions() {
    this._inductionService
      .getInductionsUsers()
      .subscribe((inductees) => {
        console.log(" inductees ", inductees)
        this.inductees = inductees || [];
        this.loading = false;
        this.updateData(inductees)
      });
  }

  private saveToFileSystem(response, name) {
    console.log("here which data is pass", response);

    return new Promise((resolve) => {
      if (response && response.data) {
        var byteArray = new Uint8Array(response.data);
        var blob = new Blob([byteArray], { type: 'application/pdf' });
        saveAs(blob, 'induction-' + name);
        resolve()
      } else {
        // this.showErrorMessage = true
        this.loading = false;
      }

      // this.loading = false;
    });
  }

  private saveToPolicyFile(response, name) {
    console.log("here second type of data pass", response);

    if (response && response.data) {
      var byteArray = new Uint8Array(response.data);
      var blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, 'policy-' + name);
      this.loading = false;

    } else {
      console.log("call this else part or not");
      // this.showErrorMessage = true
      this.loading = false;
    }

  }


  updateData(inductees) {
    console.log("UPDATING DATA = ", inductees)
    this.dataSource = new MatTableDataSource(inductees);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  download(id, index) {

    this.openSnackBar("Download will start automatically.", "Ok");
    this.selectedIndex = index
    this.load = true
    this._inductionService
      .download(id)
      .subscribe((data) => {
        console.log(" inductees ", data)
        let pdfData = data
        this.load = false
        this.selectedIndex = -1
        this.saveToFileSystem(pdfData['induction'], pdfData['name'])
          .then(() => {
            this.saveToPolicyFile(pdfData['policy'], pdfData['name']);
          });
      });
  }



  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.filterActive = false;
      this.updateData(this.inductees)
    }
    let filteredInductees = this._filter.filter(searchText, this.inductees, ['name']);
    this.updateData(filteredInductees)
    if (filteredInductees.length <= 0) {
      // this.afterFilter = "No clients with matched search text found!"
      this.afterFilter = {
        title: "No Inductees!",
        data: "Sorry, no inductees matched your search"
      }
    }
  }

}
